import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import addon_sensors, {
	addon_plus_devices_g3,
} from '@devices/settings/device_settings/addon_sensors.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import virtual_components from '@devices/settings/device_settings/virtual_components.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import app from '@devices/settings/device_settings/app.js';
import share from '@devices/settings/device_settings/share.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'Shellyi4G3',
	friendly_name: 'i4DC Gen3',
	family: 'inputs_reader',
	isPM: false,
	addons: addon_plus_devices_g3,
	reset_from_input: true,
	modes: {
		inputs_reader: {
			channels: 4,
			notifications: ['offline', 'device_problem', 'overtemperature'],
			settings: [
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				virtual_components,
				networks_gen_2_plus,
				bluetooth_gen_2,
				app,
				share,
				{
					title: 'settings',
					components: [
						{ title: 'eco_mode', component: 'eco_mode_g2' },
						{ title: 'input', component: 'input_output_g2' },
						{
							title: 'virtual_input',
							component: 'virtual_input_g2',
							min_ver: '1.3.0',
						},
						{
							title: 'enable_input',
							component: 'enable_input_g2',
							min_ver: '1.0.7',
						},
						{ title: 'invert_input', component: 'invert_switch_g2' },
						{ title: 'firmware_version', component: 'firmware_update' },
						{ title: 'geo_location_and_time_zone', component: 'location_g2' },
						{ title: 'device_reboot', component: 'device_reboot' },
						{ title: 'factory_reset', component: 'factory_reset' },
						{ title: 'device_information', component: 'device_information' },
					],
				},
			],
		},
	},
};
